/* global am4core */
/* eslint-disable no-unused-vars */
if (typeof am4core !== 'undefined') {
    var infoConfig = {

        /**
         * Black Magnify glass SVG
         */
        magIconBlack: '',

        /**
         * White Magnify glass SVG
         */
        magIconWhite: '',

        /**
         * Theme variables
         */
        themes: {
            light: {
                font: "#000",
                tooltipSeriesFill: "#fff",
                tooltipDateFont: "#fff",
                tooltipDateFill: "#000",
                magIconBgFill: "#fff",
                magIcon: '',
                magIconHover: '',
                scrollBackground: '#f3f3f3',
                gripBackground: "#ccc"
            },
            dark: {
                font: "#fff",
                tooltipSeriesFill: "#1a1820",
                tooltipDateFont: "#000",
                tooltipDateFill: "#fff",
                magIconBgFill: "#000",
                magIcon: '',
                magIconHover: '',
                scrollBackground: '#171717',
                gripBackground: "#444"
            }
        },

        /**
         * Chart title font size
         */
        titleFontSize: 14,

        /**
         * Tooltip font size
         */
        tooltipFontSize: 14,

        /**
         * Overall chart font size
         */
        fontSize: 14,

        /**
         * Tooltip series stroke width
         */
        tooltipSeriesStrokeWidth: 2,

        /**
         * Tooltip Date axis stroke width
         */
        tooltipDateAxisStrokeWidth: 0,

        /**
         * English Labels
         */
        labelsEn: {
            'percent': '%',
            'viewsChart': {
                'textViews': 'views',
                'titleDay': 'Views by date',
                'titleWeek': 'Views by week',
                'titleMonth': 'Views by month'
            },
            'deviceChart': {
                'titleText': 'Users by device category',
                'names': ["Desktop", "Mobile", "Tablet"]
            },
            'dateFormats': {
                'monthYearFormat': "MMM yyyy",
                'ttDateFormat': "MMM d',' yyyy",
                'dayDateFormat': "MMM d",
                'monthDateFormat': "MMM",
                'yearFormat': "yyyy"
            }
        },

        /**
         * French labels
         */
        labelsFr: {
            'percent': ' %',
            'viewsChart': {
                'textViews': 'vues',
                'titleDay': 'Vues par date',
                'titleWeek': 'Vues par semaine',
                'titleMonth': 'Vues par mois'
            },
            'deviceChart': {
                'titleText': 'Utilisateurs par type d’appareil',
                'names': ["Ordinateurs ", "Téléphones mobiles ", "Tablettes "]
            },
            'dateFormats': {
                'monthYearFormat': "[text-transform: lowercase]MMM[/] yyyy",
                'ttDateFormat': "d MMM yyyy",
                'dayDateFormat': "d MMM",
                'monthDateFormat': "[text-transform: lowercase]MMM[/]",
                'yearFormat': "yyyy"
            }
        },

        /**
         * Setup the variables
         * @returns {void}
         */
        setup: function () {
            this.magIconBlack = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA5NiA5NiIgaGVpZ2h0PSI5NnB4IiBpZD0iem9vbV9vdXQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDk2IDk2IiB3aWR0aD0iOTZweCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgZmlsbD0iI2ZmZiI+PHBhdGggeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBkPSJNOTAuODI5LDg1LjE3MUw2OC4xMjEsNjIuNDY0QzczLjA0Nyw1Ni4zMDcsNzYsNDguNSw3Niw0MEM3NiwyMC4xMTgsNTkuODgyLDQsNDAsNEMyMC4xMTgsNCw0LDIwLjExOCw0LDQwczE2LjExOCwzNiwzNiwzNiAgYzguNSwwLDE2LjMwNi0yLjk1MywyMi40NjQtNy44NzlsMjIuNzA4LDIyLjcwOGMxLjU2MiwxLjU2Miw0LjA5NSwxLjU2Miw1LjY1NywwQzkyLjM5MSw4OS4yNjcsOTIuMzkxLDg2LjczMyw5MC44MjksODUuMTcxeiAgIE00MCw2OGMtMTUuNDY0LDAtMjgtMTIuNTM2LTI4LTI4czEyLjUzNi0yOCwyOC0yOGMxNS40NjQsMCwyOCwxMi41MzYsMjgsMjhTNTUuNDY0LDY4LDQwLDY4eiIvPjxwYXRoIGQ9Ik01Niw0MGMwLDIuMjA5LTEuNzkxLDQtNCw0SDI4Yy0yLjIwOSwwLTQtMS43OTEtNC00bDAsMGMwLTIuMjA5LDEuNzkxLTQsNC00aDI0QzU0LjIwOSwzNiw1NiwzNy43OTEsNTYsNDBMNTYsNDB6Ii8+PC9zdmc+";
            this.magIconWhite = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDk2IDk2IiBoZWlnaHQ9Ijk2cHgiIGlkPSJ6b29tX291dCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgOTYgOTYiIHdpZHRoPSI5NnB4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNOTAuODI5LDg1LjE3MUw2OC4xMjEsNjIuNDY0QzczLjA0Nyw1Ni4zMDcsNzYsNDguNSw3Niw0MEM3NiwyMC4xMTgsNTkuODgyLDQsNDAsNEMyMC4xMTgsNCw0LDIwLjExOCw0LDQwczE2LjExOCwzNiwzNiwzNiAgYzguNSwwLDE2LjMwNi0yLjk1MywyMi40NjQtNy44NzlsMjIuNzA4LDIyLjcwOGMxLjU2MiwxLjU2Miw0LjA5NSwxLjU2Miw1LjY1NywwQzkyLjM5MSw4OS4yNjcsOTIuMzkxLDg2LjczMyw5MC44MjksODUuMTcxeiAgIE00MCw2OGMtMTUuNDY0LDAtMjgtMTIuNTM2LTI4LTI4czEyLjUzNi0yOCwyOC0yOGMxNS40NjQsMCwyOCwxMi41MzYsMjgsMjhTNTUuNDY0LDY4LDQwLDY4eiIvPjxwYXRoIGQ9Ik01Niw0MGMwLDIuMjA5LTEuNzkxLDQtNCw0SDI4Yy0yLjIwOSwwLTQtMS43OTEtNC00bDAsMGMwLTIuMjA5LDEuNzkxLTQsNC00aDI0QzU0LjIwOSwzNiw1NiwzNy43OTEsNTYsNDBMNTYsNDB6Ii8+PC9zdmc+";

            this.themes.light.magIcon = this.magIconBlack;
            this.themes.light.magIconHover = this.magIconWhite;

            this.themes.dark.magIcon = this.magIconWhite;
            this.themes.dark.magIconHover = this.magIconBlack;
        }
    };
    infoConfig.setup();
}
